module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "guillermo-garrido.6c934906.jpeg" + "?" + Date.now();